import { PlusIcon } from '@phosphor-icons/react';
import { captureException } from '@sentry/react';
import { Button } from 'components/button/Button';
import { Card } from 'components/Card';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { Input } from '../../../../../components/input/Input';
import { getDisplayError } from '../../../../../utils/get-display-error';
import { updateGeneralSettings } from '../../../models';

interface SelfBillingDiscountSectionProps {
  currentPercentage: number;
  onSaved: () => void;
}

/**
 * Cash discount applied on self-billing invoices for PC7 carriers. Deducted
 * before VAT when the self-bill is generated.
 */
export const SelfBillingDiscountSection: React.FC<SelfBillingDiscountSectionProps> = ({
  currentPercentage,
  onSaved,
}) => {
  const [value, setValue] = useState(String(currentPercentage));
  const [isSaving, setIsSaving] = useState(false);

  const hasChanged = value !== String(currentPercentage);

  const handleSave = async () => {
    const numValue = parseFloat(value.replace(',', '.'));
    if (isNaN(numValue) || numValue < 0 || numValue > 100) {
      toast.error('Percentage moet tussen 0 en 100 liggen');
      return;
    }
    setIsSaving(true);
    try {
      await updateGeneralSettings({ selfBillingCashDiscountPercentage: numValue });
      toast.success('Kortingspercentage aangepast');
      onSaved();
    } catch (err) {
      captureException(err);
      toast.error('Kon percentage niet aanpassen: ' + getDisplayError(err));
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Card
      title="Self billing - Korting voor contant"
      subtitle="Kortingspercentage voor vroegtijdige betaling op self billing facturen van PC7-carriers (Contant 7 dagen). 0 = geen korting."
    >
      <div className="flex items-center gap-4">
        <div className="w-48 text-sm font-medium text-fg">Percentage (%)</div>
        <div className="w-32">
          <Input type="number" value={value} onChange={setValue} />
        </div>
        {hasChanged && (
          <Button
            type="button"
            color="primary"
            onTrigger={handleSave}
            isDisabled={isSaving}
            isLoading={isSaving}
            iconLeft={<PlusIcon className="button-icon" />}
          >
            Opslaan
          </Button>
        )}
      </div>
    </Card>
  );
};
